var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"message":"Mark as Primary Card"}},[(!_vm.item.is_primary)?_c('v-btn',{attrs:{"color":"primary","loading":_vm.isLoading,"icon":""},on:{"click":function($event){return _vm.markPrimaryCard(_vm.item)}}},[_c('v-icon',[_vm._v("mdi-credit-card-check")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }